import { buttonVariants } from '@/app/common/components/button/buttonVariants'
import IconBox from '@/app/common/components/IconBox'
import { AppRoutePaths } from '@/routing/route_paths'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/shad/ui/dialog'
import { Check } from 'lucide-react'
import { Link } from 'react-router-dom'

type Props = {
  open: boolean
  providerId: number
}

export default function ProductAddedDialog({ open, providerId }: Props) {
  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent showClose={false} className="sm:max-w-[520px] p-0">
        <div className="p-5">
          <DialogHeader className="mb-2">
            <DialogTitle className="text-xl">
              Product added successfully
            </DialogTitle>
          </DialogHeader>

          <div className="mt-4 flex items-start gap-3">
            <IconBox size="lg">
              <Check className="h-5 w-5 text-green-600" />
            </IconBox>
            <div className="flex-1">
              <div className="font-medium">Product is Active</div>
              <div className="text-sm text-gray-600">
                The product has been approved and is now active in the
                marketplace.
              </div>
            </div>
          </div>

          <div className="mt-10">
            <Link
              className={buttonVariants({
                variant: 'primary',
                className: 'w-full',
                size: 'lg',
              })}
              to={AppRoutePaths.providers.provider_details.marketplace.replace(
                ':providerId',
                providerId.toString()
              )}
            >
              Okay
            </Link>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
